import React, {useContext} from 'react'
import PropTypes from 'prop-types'
import {   
    Typography,makeStyles, Modal, Fade, Backdrop, Button
   
    } from '@material-ui/core'; 
import UserContext from '../../context/Globales/UserContext';

import IcpdfDetalleEmpresaModal from '../pdf/IC/IcpdfDetalleEmpresaModal';

const useStyles = makeStyles((theme) => ({ 
    tituloTable: {

       backgroundColor: theme.palette.fondotitulos.main,
      // backgroundImage : `url(${FondoImagenes})`,
       
       minWidth: 200,
       color: '#171717',
       textAlign: 'center',
       padding: '20px',
       fontWeight: '250',
       fontSize : '35px'
    },  

    modalPdf: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
      },
      paperPdf: {
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
        width: '50%',
      },

}));

const TblDetalleEmpresa = props => {
    const classes = useStyles();
   
    const { datoICMODAL } = useContext(UserContext);
    const [OpenModalpdfDetalle, setOpenModalpdfDetalle] =React.useState(false); 


    const handleClickOpenModal =()=>{

        setOpenModalpdfDetalle(!OpenModalpdfDetalle); 
    }; 

    return (
        <>

        {/*MODAL PDF INFORME COMER*/}

        <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                className={classes.modalPdf}
                open={OpenModalpdfDetalle}
                onClose={handleClickOpenModal}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 2000,
                }}>
                <Fade in={OpenModalpdfDetalle}>

                    <div className={classes.paperPdf}>


                        <IcpdfDetalleEmpresaModal />



                    </div>

                </Fade>
            </Modal>






<div className={classes.tituloTable}>
        {datoICMODAL.Identificacion?.IsEmpresa ? datoICMODAL.DetalleIdentificacionEmpresa?.Nombre : datoICMODAL.Identificacion?.Nombre} <br />
         {datoICMODAL.Identificacion?.Rut}
         <br />
            {datoICMODAL.DetalleIdentificacionEmpresa!=null ? <div style={{alignContent:"center", textAlign : "center"}}><Button variant="contained" color="primary" onClick={handleClickOpenModal}>Descargar PDF</Button></div> : ''}
            <br />  

</div>     

{/*Empresa*/}
        <div className="container">
        {datoICMODAL.DetalleIdentificacionEmpresa==null ? '' : '' }
        <p align="center">{datoICMODAL.DetalleIdentificacionEmpresa.DatosExtras?.Tramo?.Descripcion}</p> <br />
        <Typography variant="body2"  ><strong>Cantidad de Trabajadores: &nbsp;</strong>{datoICMODAL.DetalleIdentificacionEmpresa.DatosExtras?.NumeroTrabajadores}</Typography><hr />
        <Typography variant="body2"  ><strong>Tipo de Contribuyente: &nbsp;</strong>{datoICMODAL.DetalleIdentificacionEmpresa.DatosExtras?.TipoContribuyente}</Typography><hr />
        <Typography variant="body2"  ><strong>Sub Tipo de Contribuyente:&nbsp;</strong>{datoICMODAL.DetalleIdentificacionEmpresa.DatosExtras?.SubTipoContribuyente} </Typography><hr />
        <Typography variant="body2"  ><strong>Rubro:&nbsp;</strong>{datoICMODAL.DetalleIdentificacionEmpresa.DatosExtras?.Rubro}</Typography><hr />
        <Typography variant="body2"  ><strong>Sub Rubro:&nbsp;</strong>{datoICMODAL.DetalleIdentificacionEmpresa.DatosExtras?.SubRubro}</Typography><hr />
        <Typography variant="body2"  ><strong>Actividad:&nbsp;</strong>{datoICMODAL.DetalleIdentificacionEmpresa.DatosExtras?.Actividad}</Typography><hr />
        <Typography variant="body2"  ><strong>Región:&nbsp;</strong>{datoICMODAL.DetalleIdentificacionEmpresa.DatosExtras?.Region}</Typography><hr />
        <Typography variant="body2"  ><strong>Provincia:&nbsp;</strong>{datoICMODAL.DetalleIdentificacionEmpresa.DatosExtras?.Provincia}</Typography><hr />
        <Typography variant="body2"  ><strong>Comuna:&nbsp;</strong>{datoICMODAL.DetalleIdentificacionEmpresa.DatosExtras?.Comuna}</Typography><hr />

        </div>



        </>
    )
}

TblDetalleEmpresa.propTypes = {

}

export default TblDetalleEmpresa
